import axios from 'axios';
import { Cookies } from 'react-cookie';
import { selector } from 'recoil';
import { URL_FOUNDATION } from '../../config/keys';

// -----------------------[ TYPES ]----------------------- //
type ReportFields = 'shelf_audit' | 'orders'

type FieldReportInstaller = {
	id: number
	companyId: number
	userId: number
	name: ReportFields
	createdAt: Date
	updatedAt?: Date
	deletedAt?: Date
}

// -----------------------[ ATOM ]----------------------- //
export const AFieldReportInstallers = selector({
	key: 'AFieldReportInstallers',
	get: async({ get: _ }) => getFieldReportInstallers()
});

// -----------------------[ API ]------------------------ //
const cookies = new Cookies();
const token: string | null = cookies.get('id_token') || null;

axios.defaults.headers.common.Authorization = `${token ?? ''}`;

async function getFieldReportInstallers(): Promise<FieldReportInstaller[]> {
	axios.defaults.headers.common.Authorization = `${token}`;
	try {
		return await axios.get(`${URL_FOUNDATION ?? ''}/api/v2/field-report-installers`).then(res => res.data);
	} catch (e) {
		console.log(e);
		return [];
	}
}
